import * as React from 'react';

export const ArrowUpRightIcon = ({ className }: { className?: string }) => (
  <svg className={className} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.5 6.375V8.375H15.09L5.5 17.965L6.91 19.375L16.5 9.785V18.375H18.5V6.375H6.5Z" fill="currentColor" />
  </svg>
);
